module.exports = __webpack_public_path__ + "static/media/promo.0192a35a.svg";